import nativeBase64 from "react-native-base64";
// import * as CryptoJS from 'crypto-js';

let CryptoJS: any;

export const SessionService = {
  token: () => {
    const token = localStorage.getItem("token");
    return token && isValidBase64(token) ? safeDecrypt(token) : null;
  },

  setToken: (token: string) => {
    localStorage.setItem("token", encrypt(token));
  },

  user: () => {
    const user = localStorage.getItem("user");
    return user && isValidBase64(user) ? safeDecrypt(user) : null;
  },

  setUser: (user: any) => {
    localStorage.setItem("user", encrypt(user));
  },

  reset: () => {
    localStorage.clear();
  },
};

// ✅ Encoding stays the same
const encrypt = (data: any): string => {
  return nativeBase64.encode(JSON.stringify(data));
};

// ✅ Safe Decrypt + JSON parse
const safeDecrypt = (str: string) => {
  try {
    const decoded = nativeBase64.decode(str);
    return JSON.parse(decoded);
  } catch (err) {
    console.error("Failed to decrypt or parse data:", err);
    return null;
  }
};

// ✅ Add base64 format validation
function isValidBase64(str: string): boolean {
  try {
    return /^[A-Za-z0-9+/=]+$/.test(str) && btoa(atob(str)) === str;
  } catch {
    return false;
  }
}
